








import Vue from "vue";
import {HTTP} from "@/utils/httpCommonUtil";
import AuthMixin from "@/mixins/AuthMixin";

export default Vue.extend({
  name: 'Token',
  data() {
    return {
      error: ''
    };
  },
  mixins: [AuthMixin],
  async created() {
    const theMixin = this as any; // Stupid hack for legacy Vue to shut up warnings for stuff in Mixin
    try {
      let {code, state} = this.$route.query;
      if (state !== sessionStorage.getItem(theMixin.STATE_KEY)) {
        this.showError('Invalid Login');
        return;
      }

      const url = `${theMixin.getBaseOauthUrl()}/token`;
      const data = new URLSearchParams();
      data.append('grant_type', 'authorization_code');
      data.append('code', code);
      data.append('client_id', theMixin.getAppClientId());
      data.append('redirect_uri', theMixin.getRedirectUrl());
      data.append('code_verifier', sessionStorage.getItem(theMixin.CODE_VERIFIER_KEY) as any as string);

      const { data: responseData } = await HTTP.post(url, data);

      await this.completeLogin(responseData.id_token, responseData.expires_in, responseData.access_token);
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        this.showError(e.response.data.error);
      } else {
        console.error(e);
        this.showError('Failed to login');
      }
    }
  },
  methods: {
    async completeLogin(token: string, expiresIn: number, accessToken: string) {
      this.$store.commit('user/setToken', { token, expiresIn, accessToken });

      const oldAppUser = this.$store.state.user.appUserId;

      const { data: responseData } = await HTTP.get('/api/current-user');
      this.$store.commit('user/setUser', responseData.data);
      const newAppUser = this.$store.state.user.appUserId;
      if (this.$store.state.user.lastRoute && (!oldAppUser || oldAppUser === newAppUser)) {
        this.$router.replace({ path: this.$store.state.user.lastRoute });
      } else {
        this.$router.push('/calendar-shifts');
      }
    },
    showError(error: string) {
      this.error = error;
      setTimeout(() => {
        window.location.href = '/login';
      }, 5000);
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/Token.vue